import { useFeatureFlag } from '@glossgenius/core-features-react-sdk';

import { FEATURE_FLAGS } from 'core-features-config/activeFeatureFlags';

import { useBusiness } from 'hooks/business/useBusiness';

export const useFooter = () => {
  const { address, showAddress } = useBusiness();
  const { isEnabled: isPackagePurchaseEnabled } = useFeatureFlag(
    FEATURE_FLAGS.PACKAGE_PURCHASE,
  );
  const termsOfServiceUrl = isPackagePurchaseEnabled
    ? 'https://glossgenius.com/legal/user-terms'
    : 'https://glossgenius.com/terms';
  const privacyPolicyUrl = 'https://glossgenius.com/privacy';
  const addressLink = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    address,
  )}`;

  return {
    address,
    addressLink,
    privacyPolicyUrl,
    showAddress,
    termsOfServiceUrl,
  };
};
